import { createActions } from 'redux-actions';
import { FormValues } from './type';
import { SignInWithUsernameAuthParams } from '@apis/AuthApi';

export const { usernameSignIn, usernameSignInError } = createActions('USERNAME_SIGN_IN', 'USERNAME_SIGN_IN_ERROR', {
  prefix: 'SIGN_IN_USERNAME_PAGE',
});

export type UsernameSignInPayload = SignInWithUsernameAuthParams;

export interface State {
  errors: Partial<FormValues>;
}
